import type { ReactNode } from "react";
import { PlatformDashboardPage } from "./PlatformDashboardPage";

export function PddDashboardPage({ onMenuOpen, platformNav }: { onMenuOpen: () => void; platformNav?: ReactNode }) {
  return <PlatformDashboardPage onMenuOpen={onMenuOpen} platform="pdd" platformNav={platformNav} />;
}
